import { Alert } from '@/modules/market-signals/model/social-media';
import nlp from 'compromise';

export function escapeRegex(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function formatTime(date: Date): string {
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function getMatchedAlerts(
  postContent: string,
  alerts: Alert[],
  smartMatching = false,
): Alert[] {
  if (!postContent || alerts.length === 0) return [];

  const matched: Alert[] = [];
  const lowerContent = postContent.toLowerCase();

  const rootsInPost = smartMatching
    ? (() => {
        const doc = nlp(postContent).compute('root');
        const terms = doc.json()[0]?.terms || [];
        const roots = new Set<string>();
        for (const term of terms) {
          const root = (term.root || term.normal || '').toLowerCase();
          if (root) roots.add(root);
        }
        return roots;
      })()
    : null;

  for (const alert of alerts) {
    const lowerWord = alert.word.toLowerCase();
    let matches = lowerContent.includes(lowerWord);

    if (!matches && smartMatching && rootsInPost) {
      const alertTerm = nlp(alert.word).compute('root').json()[0]?.terms?.[0];
      const alertRoot = (alertTerm?.root || alertTerm?.normal || '').toLowerCase();
      matches = alertRoot && rootsInPost.has(alertRoot);
    }

    if (matches) {
      matched.push(alert);
    }
  }

  return matched;
}
